<template>
  <div id="app">
    <router-view :key="$route.fullPath"></router-view>
    <!-- set progressbar -->
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<style>
@import url("https://fonts.googleapis.com/css?family=Lato:300,400,700,900");
*:focus {
  outline: none !important;
}

#app {
  font-family: "Lato", sans-serif;
  color: #7d8593;
}

.auth-page {
  background-image: url("./assets/img/bg.png");
}
a {
  color: #1d3964;
  font-size: .9375rem;
}
a:hover{
  color: #193156;

}
.__cov-progress {
  height: 3px !important;
}
.obligatoire {
  color: red;
  padding-left: 5px
}
/*.flex-1 {
    flex: 1 1 auto !important;
}*/
</style>

<script>
import { mapGetters } from "vuex";
import { CLEAR_ERROR,FETCH_APPLICATION } from "@/store/actions.type";

export default {
  name: "App",
  computed: {
    ...mapGetters([
      "session",
      "currentUser"
    ]),
  },
  data(){
    return{
      pending: ['3', '6','8']
    }
  },
  watch: {
    $route() {
      if(this.$route.meta.title) document.title = this.$route.meta.title;
      // clear alert on location change
      this.$store.dispatch(CLEAR_ERROR);
      if (this.isAuthenticated && this.session.application_session == null && this.currentUser.role != 'sso') {
        this.$store.dispatch(FETCH_APPLICATION);
      }
    }
  }
};
</script>
